import React from "react";
import PricingHeaderSection from "./PricingPage/PricingHeaderSection";
import PricingCards from "./PricingPage/PricingCards";
import PricingBanner from "./PricingPage/PricingBanner";
import PricingHeaderBanner from "./PricingPage/PricingHeaderBanner";
import PricingFooterContact from "./PricingPage/PricingFooterContact";

const PricingPage = () => {
  return (
    <>
      <PricingHeaderSection />
      <PricingHeaderBanner />
      <PricingCards />
      <PricingBanner />
      <PricingFooterContact />
    </>
  )
}

export default PricingPage